import React from "react";
import { ResponsiveModal } from "@UI/Components/ResponsiveModal/ResponsiveModal";
import { CircleCheck } from "@UI/Components/Icons/CircleCheck";
import { VStack } from "@UI/Components/Stack/Stack";
import { Icon } from "@UI/Components/Icon/Icon";
import { Heading } from "@UI/Components/Heading/Heading";
import { Text } from "@UI/Components/Text/Text";
import { Button } from "@UI/Components/Button/Button";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";

import messages from "./messages";
import { PaymentMethodType } from "@modules/PaymentProcessing/types";
import { useServiceOffer } from "@modules/ServiceAssignment/hooks/useServiceOffer";

interface Props {
  isOpen: boolean;
  paymentMethod: PaymentMethodType;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleConfirm: any;
  serviceOfferId: string;
}

export const ConfirmationModal = ({
  isOpen,
  paymentMethod,
  handleConfirm,
  serviceOfferId,
}: Props) => {
  const { serviceOffer } = useServiceOffer(serviceOfferId);
  const {
    user: { firstName },
  } = serviceOffer?.serviceProvider;
  return (
    <ResponsiveModal
      closeOnOverlayClick={false}
      closeOnEsc={false}
      isOpen={isOpen}
      closeButtonDisabled
      onClose={() => undefined}
    >
      <VStack justifyContent="center" spacing="4" pb={{ base: 2, md: 9 }}>
        <Icon as={CircleCheck} w="12" h="12" color="success" />
        <Heading>
          <FormattedMessage
            {...(paymentMethod === PaymentMethodType.BANK_TRANSFER
              ? messages.waitingForBankTransfer
              : messages.paymentConfirmed)}
          />
        </Heading>
        <Text textAlign="center">
          <FormattedMessage
            {...messages.paymentConfirmedInformations}
            values={{
              serviceProviderName: firstName,
            }}
          />
        </Text>
        <Button
          w="full"
          onClick={handleConfirm}
          size="lg"
          colorScheme="seaGreen"
        >
          <FormattedMessage {...messages.continue} />
        </Button>
      </VStack>
    </ResponsiveModal>
  );
};
